import { render, staticRenderFns } from "./subsidyReview.vue?vue&type=template&id=09743c22&scoped=true"
import script from "./subsidyReview.vue?vue&type=script&lang=js"
export * from "./subsidyReview.vue?vue&type=script&lang=js"
import style0 from "./subsidyReview.vue?vue&type=style&index=0&id=09743c22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09743c22",
  null
  
)

export default component.exports